import { CheckCircle, Clock } from "lucide-react";

/**
 * Top header bar + status badge shown on the customer-facing quote page.
 */
const QuotePageTopBar = ({ quote }) => {
  const isSigned = !!quote.signature_name;
  const isPaid = quote.payment_status === "paid";

  return (
    <>
      <header className="bg-[#00341d] text-white py-6">
        <div className="max-w-5xl mx-auto px-6">
          <div className="flex items-center justify-between">
            <img
              src="https://customer-assets.emergentagent.com/job_665c49ba-1471-4262-8719-d672e8150062/artifacts/l1uvt1c1_Logo_Framed_Green.png"
              alt="Land ClearCo"
              className="h-12"
            />
            <p className="text-xs text-white/70 tracking-wide text-right" data-testid="gc-license-line">
              NC GC License # 110193<br className="sm:hidden" />
              <span className="hidden sm:inline"> | </span>Class H - Excavation &amp; Grading (Limited)
            </p>
          </div>
        </div>
      </header>

      {/* Quote card header strip */}
      <div className="bg-gradient-to-r from-zinc-50 to-white p-8 border-b border-zinc-200">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
          <div className="flex items-start gap-6">
            <img
              src="https://customer-assets.emergentagent.com/job_06366a4e-f06e-49f6-ad8a-6605b3e3cdc0/artifacts/bgzxu9sq_Logo%20Yellow%20%2B%20Silver%20%2810x8%29.png"
              alt="Land ClearCo"
              className="h-20 w-auto object-contain"
            />
            <div>
              <p className="text-sm font-medium text-zinc-500 uppercase tracking-wider mb-1">Quote</p>
              <h1 className="font-heading text-4xl font-bold text-[#00341d] uppercase tracking-tight">
                {quote.quote_number}
              </h1>
              <p className="text-zinc-500 mt-2">
                Created{" "}
                {new Date(quote.created_at).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            {isPaid ? (
              <span className="px-4 py-2 bg-[#00341d] text-white rounded-full text-sm font-bold uppercase tracking-wider flex items-center gap-2">
                <CheckCircle className="w-4 h-4" />
                Paid
              </span>
            ) : isSigned ? (
              <span className="px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-bold uppercase tracking-wider flex items-center gap-2">
                <CheckCircle className="w-4 h-4" />
                Signed - Awaiting Payment
              </span>
            ) : (
              <span className="px-4 py-2 bg-amber-100 text-amber-800 rounded-full text-sm font-bold uppercase tracking-wider flex items-center gap-2">
                <Clock className="w-4 h-4" />
                Pending Signature
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default QuotePageTopBar;
